import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStateService {
  isInitialized = signal(false);
  hasError = signal(false);
  errorDetails = signal<any>(null);

  setInitialized(value: boolean) {
    this.isInitialized.set(value);
  }

  setError(error: any) {
    this.hasError.set(true);
    this.errorDetails.set(error);
  }
}
